export default {
    append: {
        kgPerWeight: '/ kg of body weight',
        gr: 'gr',
        g: 'g',
        age: 'years',
        months: 'months',
        height: 'cm',
        weight: 'kg',
        mg_dl: 'mg/dl',
        kcal: 'kcal'
    },
    age: 'Age',
    height:'Height',
    weight: 'Weight',
    cole: {
        title: "Children's BMI grade (IOTF 2012)",
        subtitle: 'Grades children aged 2 to 18 by their BMI.',
        gender: 'Gender',
        boy: 'Boy',
        girl: 'Girl',
        btn: 'Grade',
        placeholder: {
            years: 'e.g. 9',
            months: 'e.g. 4',
            height: "Child's height in cm",
            weight: "Child's weight in kg",
        },
        bmi: {
            resultPrefix: 'BMI',
            underTwo: "BMI isn't graded under 2 years. See weight-for-length on the customer's growth curves.",
            checkValues: 'Check the age, the height (in cm) and the weight (in kg).',
            results: {
                0: 'Obesity',
                1: 'Overweight',
                2: 'Normal weight',
                3: 'Underweight',
                4: 'Severely underweight'
            }
        }
    },
    bmi: {
        menu: 'Δείκτης Μάζας Σώματος Ενηλίκων',
        title: 'Υπολογισμός Δείκτη Μάζας Σώματος',
        subtitle: 'Χαρακτηρισμός επιπέδου υγείας με βάση τον Δ.Μ.Σ.',
        placeholder:{
            height: 'Εισάγετε το ύψος σε εκατοστά',
            weight: 'Εισάγετε το βάρος σε κιλά (kg)',
        },
        btn: 'Υπολογισμός Δ.Μ.Σ.',
        result: {
            prefix: 'Το BMI είναι',
            0: 'Ελλιποβαρής',
            1: 'Φυσιολογικό Βάρος',
            2: 'Υπέρβαρος',
            3: 'Παχύσαρκος Ι',
            4: 'Παχύσαρκος ΙΙ',
            5: 'Νοσογόνος Παχυσαρκία'
        }
    },
    insulin: {
        menu: 'Πιθανότητα αντίστασης στην ινσουλίνη',
        triglycerides: 'Τριγλυκερίδια νηστείας',
        glucose: 'Γλυκόζη νηστείας',
        btn: 'Υπολογισμός πιθανότητας',
        low: 'υψηλή',
        high: 'χαμηλή',
        result: {
            prefix: 'Ο δείκτης TyG είναι ίσος με',
            title: 'Υπάρχει <strong><u>{result}</u></strong> πιθανότητα αντίστασης στην ινσουλίνη',
            nafld: 'Υπάρχει πιθανότητα ύπαρξης Λιπώδης Διήθησης (NAFLD)'
        }
    },
    fiber: {
        menu: 'Ημερήσια πρόσληψη διαιτητικών ινών',
        dailyIntake: 'Ημερήσια πρόσληψη ενέργειας',
        placeholder:{
            dailyIntake: 'Ημερήσια πρόσληψη ενέργειας σε kcal',
        },
        btn: 'Calculate',
        result: 'Συνίσταται πρόσληψη <u><strong>{result}{unit}</strong> διαιτητικών ινών</u> ανά ημέρα.'
    },
    gfr: {
        menu: 'Χρόνια Νεφρική Ανεπάρκεια',
        title: 'Χρόνια Νεφρική Ανεπάρκεια - GFR Cockcroft-Gault',
        subtitle: 'Υπολογισμός με την εξίσωση GFR Cockcroft-Gault.',
        kreatin: 'Κρεατινίνη Ορού',
        placeholder: {
            kreatin: 'Κρεατινίνη Ορού'
        },
        btn: 'Calculate',
        results: {
            0: 'Στάδιο 1 με φυσιολογικό ή υψηλό GFR',
            1: 'Στάδιο 2 Ήπια ΧΝΑ',
            2: 'Στάδιο 3Α Μέτρια ΧΝΑ',
            3: 'Στάδιο 3Β Μέτρια ΧΝΑ',
            4: 'Στάδιο 4 Σοβαρή ΧΝΑ',
            5: 'Στάδιο 5 Τελικό Στάδιο ΧΝΑ'
        }
    },
    hamwi: {
        menu: 'Ιδανικό & Προσαρμοσμένο Βάρος',
        title: 'Ιδανικό & Προσαρμοσμένο Βάρος',
        subtitle: 'Υπολογίζεται με βάση την εξίσωση Hamwi.',
        ideal: 'Ιδανικό Βάρος',
        adjusted: 'Προσαρμοσμένο Βάρος',
    }
}